import styled, { css } from 'styled-components';
import theme from 'src/theme';
import { PanelProps, TabsPanelHeader } from '../../styles/panel.style';
import { ButtonWrapper } from '../../styles/button.style';
export interface IButtonProps {
    isSelected?: boolean;
    onClick?: (eventTypeId: number) => void;
}

export interface IPanelProps {
    isExpanded?: boolean;
}

export const PageContentWrapper = styled.div`
    height: 100%;
    padding: 0 5px 5px;
    display: flex;
    justify-content: space-between;

    @media print {
        height: auto;
        width: 100%;
        display: block;
        padding: 0;
    }
`;

export const LeftContentWrapper = styled.div<IPanelProps>`
    flex: 0 0 calc(75% - 5px);
    flex-grow: 0;
    overflow: hidden;
    height: 100%;
    box-shadow: ${({ theme }) => theme.colors.panel.shadow} 0 2px 6px 2px;

    ${({ isExpanded }) =>
        isExpanded &&
        css`
            flex: 0 0 calc(45% - 5px);
            max-width: calc(45% - 5px);
        `}

    @media print {
        display: none;
    }
`;

export const VerificationTable = styled.div<IPanelProps>`
    height: 100%;
    .verification-table,
    .verification-response-table {
        &.header {
            li {
                font-weight: 500;
                background: ${({ theme }) => theme.colors.verification.header.background};
                border-bottom: 1px solid ${({ theme }) => theme.colors.verification.header.border};
                color: ${({ theme }) => theme.colors.brand.darkBlue};
                display: flex;
                justify-content: flex-start;
                padding-right: 17px;
                height: 34px;
                line-height: 1.05;
                .icon {
                    margin: 0 0 0 5px;
                }
            }
        }
        &.list {
            overflow-y: scroll;
            overflow-x: hidden;
            height: calc(100% - 110px);

            .col {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        li {
            box-shadow: 0 5px 5px -3px ${({ theme }) => theme.colors.tableRow.shadow};
            border-bottom: 1px solid ${({ theme }) => theme.colors.tableRow.border};
            padding: 1px 4px;
            cursor: pointer;
            color: ${({ theme }) => theme.colors.text.primary};
            font-weight: 400;
            font-size: 0.8rem;
            cursor: pointer;
            transition: background-color 50ms cubic-bezier(0.4, 0, 0.2, 1);
            padding-right: 5px;
            display: flex;
            justify-content: flex-start;
            height: 2rem;

            &.selected {
                background: ${({ theme }) => theme.colors.tableRow.background.selected} !important;
            }
            .col {
                flex: 0 0 8.5%;
                max-width: 8.5%;
                padding: 0 3px;
                display: flex;
                align-items: center;
                justify-content: flex-start;

                ${({ isExpanded }) =>
        isExpanded &&
        css`
                        flex: 0 0 13%;
                        max-width: 13%;
                    `}

                .sort-icon {
                    margin-left: 0.5rem;
                }
            }

            .col-checkbox {
                flex: 0 0 4%;
                max-width: 4%;
                min-width: 3rem;
                position: relative;
                .checkbox-wrapper {
                    position: absolute;
                    right: 2px;
                }
            }

            .col-comment {
                flex: 0 0 2%;
                max-width: 2%;
                min-width: 2rem;
            }

            .col-send {
                flex: 0 0 6%;
                max-width: 6%;
                min-width: 6rem;
            }

            .col-vessel-name {
                flex: 0 0 10%;
                max-width: 10%;
                ${({ isExpanded }) =>
        isExpanded &&
        css`
                        flex: 0 0 15%;
                        max-width: 15%;
                    `}
            }
            .col-date {
                flex: 0 0 11%;
                max-width: 11%;
                @media only screen and (max-width: 1440px) {
                    flex: 0 0 13%;
                    max-width: 13%;
                    .status-label {
                        display: none;
                    }
                }
                ${({ isExpanded }) =>
        isExpanded &&
        css`
                        flex: 0 0 13%;
                        max-width: 13%;
                    `}
            }
            .col-date-time {
                flex: 0 0 12%;
                max-width: 12%;
                ${({ isExpanded }) =>
        isExpanded &&
        css`
                        flex: 0 0 16%;
                        max-width: 16%;
                    `}
            }
            .narrow {
                flex: 0 0 6%;
                max-width: 6%;
                ${({ isExpanded }) =>
        isExpanded &&
        css`
                        flex: 0 0 10%;
                        max-width: 10%;
                    `}
            }
            .col-status {
                flex: 0 0 13%;
                max-width: 13%;
                text-align: center;
                @media only screen and (max-width: 1440px) {
                    flex: 0 0 4%;
                    max-width: 4%;
                    .status-label {
                        display: none;
                    }
                }
                ${({ isExpanded }) =>
        isExpanded &&
        css`
                        flex: 0 0 16%;
                        max-width: 16%;
                    `}
            }
            .col-issues {
                flex: 0 0 10%;
                max-width: 10%;
                text-align: center;
                @media only screen and (max-width: 1440px) {
                    flex: 0 0 8%;
                    max-width: 8%;
                }
            }
            .col-wide {
                flex: 0 0 13%;
                max-width: 13%;
                ${({ isExpanded }) =>
        isExpanded &&
        css`
                        flex: 0 0 18%;
                        max-width: 18%;
                    `}
            }

            .col-center {
                justify-content: center;
            }

            .icon {
                font-size: 0.7rem;
            }
            .green-circle {
                border-radius: 50%;
                color: #fff;
                background: green;
                width: 12px;
                height: 12px;
                padding: 1px;
                font-size: 8px;
                text-align: center;
            }
        }
    }
`;

export const VerificationIssuesWrapper = styled.div`
    height: calc(100% - 120px);
    overflow-y: auto;
    &.comment-expanded {
        height: calc(100% - 300px);
    }
`;

export const VerificationIsssuesList = styled.ul`
    &.show-grid {
        display: grid;
        grid-template-columns: 50% 50%;
        grid-gap: 5px;
    }

    li {
        box-shadow: 0 7px 12px -4px ${({ theme }) => theme.colors.verification.item.shadow};
        border: 1px solid ${({ theme }) => theme.colors.verification.item.border};
        margin: 0;
        background: ${({ theme }) => theme.colors.verification.item.background};
        padding: 0 5px;
        margin: 0 0 10px 0;
        padding: 4px;
        cursor: pointer;
        color: #04265a;
        font-weight: 400;
        font-size: 0.8rem;
        cursor: pointer;
        transition: background-color 50ms cubic-bezier(0.4, 0, 0.2, 1);
        height: fit-content;

        &.selected {
            background: ${({ theme }) => theme.colors.verification.item.selected} !important;
        }

        .row {
            font-size: 0.8rem;
            margin-bottom: 5px;
            display: flex;
            justify-content: space-between;

            &.row-2 {
                justify-content: flex-start;
                grid-gap: 5px;
                padding: 3px 0;
            }
            &.issues {
                font-weight: 500;
                justify-content: space-between;
            }
            &.heading {
                font-weight: 500;
            }
            .label {
                font-weight: 500;
                margin-right: 5px;
            }
            &.expanded {
                .col-1 {
                    flex: 0 0 40%;
                    max-width: 40%;
                    grid-gap: 5px;
                }
            }
        }
        .missing-row {
            .missing-item {
                margin: 0 10px 0 0;
            }
        }
        .warning-msg {
            background: ${({ theme }) => theme.colors.verification.status.warning};
            color: #fff;
            padding: 5px;
            border-radius: 3px;
        }
        .successful-msg {
            background: ${({ theme }) => theme.colors.verification.status.success};
            color: #fff;
            padding: 5px;
            border-radius: 3px;
        }
        .failed-msg {
            background: ${({ theme }) => theme.colors.verification.status.error};
            color: #fff;
            padding: 5px;
            border-radius: 3px;
        }
        .col-1 {
            flex: 0 0 80%;
            max-width: 80%;
            display: flex;
            justify-content: flex-start;
            grid-gap: 5px;

            span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .col-2 {
            display: flex;
            justify-content: flex-start;
            grid-gap: 5px;
        }

        .col-3 {
            justify-content: flex-end;
            grid-gap: 5px;
        }

        .issue,
        .warning {
            color: #fff;
            font-weight: 400;
            padding: 1px 6px;
            border-radius: 4px;
            font-size: 0.75rem;
            height: 20px;
        }

        .issue {
            background: orangered;
        }

        .warning {
            background: darkorange;
        }
        .desc-section {
            border-top: 1px solid #ddd;
            margin: 0;
            padding: 5px;
        }
        .header-section {
            background: #f4f4f4;
            padding: 5px 5px 10px;
        }
    }
`;

export const VerificationList = styled.div`
    height: 100%;

    .new-version-warning,
    .old-issues-warning {
        color: black;
        box-shadow: 0 5px 5px -3px #ddd;
        padding: 10px;
        display: inline-block;
        font-size: 0.8rem;
        margin: 0 0 1rem 0;
        .notice-icon {
            margin-right: 6px;
            color: orangered;
            font-size: 1.25rem;
        }
    }
`;

export const RightContentWrapper = styled.div<IPanelProps>`
    flex: 0 0 calc(25% - 5px);
    max-width: calc(25% - 5px);
    position: relative;
    height: 100%;
    box-shadow: #ccc 0 2px 6px 2px;

    ${({ isExpanded }) =>
        isExpanded &&
        css`
            flex: 0 0 calc(55% - 5px);
            max-width: calc(55% - 5px);
        `}
`;

export const LeftTopWrapper = styled.div`
    background: ${theme.legacyColors.headingPanelBgColor};
    color: ${theme.legacyColors.headingColor};
    border-bottom: 2px solid ${theme.legacyColors.headingColor};
    height: 80px;
`;

export const LeftWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    grid-gap: 10px;
`;

export const RightWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    grid-gap: 10px;
    align-items: center;
`;

export const StatusMessageWrapper = styled.div`
    h3 {
        display: inline-block;
        font-weight: 500;
        border: 2px solid ${({ theme }) => theme.colors.verification.status.success};
        border-radius: 4px;
        color: ${({ theme }) => theme.colors.verification.status.success};
        padding: 0 10px;
        font-size: 0.9rem;
    }
    h5 {
        color: ${({ theme }) => theme.colors.verification.status.success};
        font-weight: 400;
        font-size: 0.6rem;
    }
`;
export const EncourageWrapper = styled.div`
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.mrvVerified};
    padding: 5px 20px;
`;

export const LeftBottomWrapper = styled.div`
    padding: 0.25rem;
    height: 100%;
`;

export const RightTopWrapper = styled.div`
    height: 80px;
    background: ${theme.legacyColors.headingPanelBgColor};
    color: ${theme.legacyColors.headingColor};
    border-bottom: 2px solid ${theme.legacyColors.headingColor};
    padding: 0.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const VerificationTabsPanelHeader = styled(TabsPanelHeader) <PanelProps>`
    height: 80px;
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
`;

export const VerificationButtonWrapper = styled(ButtonWrapper) <PanelProps>`
    align-self: center;
`;

export const RightBottomWrapper = styled.div`
    padding: 0.25rem;
    height: 100%;
`;

export const VerificationDetails = styled.div`
    border: 1px solid ${({ theme }) => theme.colors.border.light};
    padding: 1rem;
    border-radius: 3px;
    label {
        font-weight: 500;
        font-size: 0.9rem;
    }
    .field {
        display: flex;
        flex: 1;
        width: 100%;
        justify-content: space-between;
        padding: 0.25rem 0;
    }
    .field-value {
        text-align: right;
    }
    .field-btn {
        margin-bottom: 0.5rem;
    }
    .error {
        label {
            color: ${({ theme }) => theme.colors.text.error};
        }
    }
    textarea {
        border: 1px solid ${({ theme }) => theme.colors.border.ccc};
        padding: 0.5rem;
        border-radius: 4px;
        width: 100%;
        height: 100%;
        outline: none;
    }
    .error-wrapper {
        border-bottom: 1px solid ${({ theme }) => theme.colors.border.ccc};
        padding-bottom: 1rem;
        margin-bottom: 1rem;
    }
`;

export const VerificationCommentWrapper = styled.div`
    box-shadow: 0 7px 12px -4px #ccc;
    margin: 0 0 1rem 0;

    textarea {
        width: calc(100% - 0.5rem);
        border: 1px solid #ccc;
        padding: 0.25rem;
        outline: none;
        font-size: 0.75rem;
        margin: 0 0.25rem 0.5rem 0.25rem;
        height: 100px;
    }

    button {
        margin: 0.5rem 0.25rem;
    }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem;
    border-bottom: 1px solid #ccc;
`;

export const ConfirmAccept = styled.div`
    color: ${({ theme }) => theme.colors.verification.comment.error};
    font-size: 0.8rem;
    font-weight: 500;
    box-shadow: 0 7px 12px -4px #ccc;
    padding: 0.5rem 0.25rem;
    margin: 0 0 1rem 0;

    h4{
        margin: -5px 5px 10px 0;k
        font-size: 0.9rem;
        font-weight: 500;
    } 
    h5{
        margin: -5px 5px 10px 0;k
        font-size: 0.9rem;
        font-weight: 500;
    } 
`;

export const FilterPanelWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    grid-gap: 10px;
    align-items: center;
    width: 100%;
`;

export const DropdownsWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    justify-content: flex-start;
    grid-gap: 10px;
    padding: 10px;
`;

export const SelectedText = styled.div`
    align-self: flex-end;
    color: ${theme.legacyColors.darkBlue};
    margin: 10px 0 0 0;
    font-weight: 300;
    margin: 1rem;
    font-size: 1.25rem;
`;

export const DownloadReportWrapper = styled.div`
    display: flex;
    padding: 5px;
    align-self: center;

    h5 {
        margin-top: 15px;
    }
`;

export const IssuesHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0.5rem;
`;


export const AcceptedWrapper = styled.div`
    font-weight: 500;
    color: ${theme.legacyColors.darkBlue};
`;
